import { JobStatus, SendingStatus } from '../types';

/**
 * Maps backend SendingStatus to frontend JobStatus for UI display
 *
 * Mapping rules:
 * - Accepted, SentToCustomer → applied
 * - Assigned, Registered → active
 * - Rejected, RejectedByCustomer → rejected
 */
export function mapSendingStatusToJobStatus(status: SendingStatus): JobStatus {
    switch (status) {
        case 'Accepted':
        case 'SentToCustomer':
            return 'applied';

        case 'Assigned':
        case 'Registered':
            return 'confirmed';

        case 'Rejected':
        case 'RejectedByCustomer':
            return 'rejected';

        default:
            return 'applied';
    }
}

/**
 * Maps frontend JobStatus to array of backend SendingStatus values
 * Used for API query parameters
 */
export function mapJobStatusToSendingStatuses(jobStatus: JobStatus): SendingStatus[] {
    const statusMap: Record<JobStatus, SendingStatus[]> = {
        'applied': [ 'Accepted', 'SentToCustomer' ],
        'confirmed': [ 'Assigned', 'Registered' ],
        'rejected': [ 'Rejected', 'RejectedByCustomer' ],
        'declinedByCandidate': [],
        'externalJob': []  // External jobs are fetched via separate endpoint
    };

    return statusMap[jobStatus];
}

export function getAllStatuses(): SendingStatus[] {
    return [
        'Accepted',
        'Assigned',
        'Rejected',
        'Registered',
        'SentToCustomer',
        'RejectedByCustomer'
    ];
}

/**
 * Checks if a SendingStatus is considered "active" (Assigned or Registered)
 */
export function isActiveStatus(status: SendingStatus): boolean {
    return status === 'Assigned' || status === 'Registered';
}
